module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_04_beach-photo-d7cfb208f9396eca931ecf7f18e37879.jpg";